import { XStack, YStack } from '@frontend/web-react';

export type SkeletonPlanCardProps = {
  borderColor?: 'borderPrimary' | 'borderTertiary';
  padding?: 'lg' | 'md';
};

export const SkeletonPlanCard = ({ borderColor = 'borderPrimary', padding = 'md' }: SkeletonPlanCardProps) => (
  <XStack alignItems="center" borderColor={borderColor} borderWidth={2} gapX="lg" p={padding} radius="lg">
    <YStack bg="lineGray" height={24} radius="full" width={24} />
    <YStack flex={1} gapY="xs">
      <YStack bg="lineGray" height={20} radius="md" width="40%" />
      <YStack bg="lineGray" height={24} radius="md" width="33%" />
    </YStack>
    <YStack alignItems="end" gapY="xs">
      <YStack bg="lineGray" height={16} radius="md" width={64} />
      <YStack bg="lineGray" height={16} radius="md" width={80} />
    </YStack>
  </XStack>
);

export const SkeletonPlanCardList = ({ count = 3 }: { count?: number }) => (
  <YStack gap="md">
    {Array.from({ length: count }).map((_, index) => (
      <SkeletonPlanCard key={index} />
    ))}
  </YStack>
);
